import { Injectable } from "@angular/core"
import "rxjs/add/operator/map"
import { Router } from "@angular/router"
import { globalValues } from "@app/globals"
import { CustomHttp } from "@service/customhttp.service"
import { RequestLibraryService } from "@service/core/request-library.service"
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Observable, throwError } from "rxjs"
import { catchError, map } from "rxjs/operators"
import { environment } from "@env/environment"

@Injectable()
export class EmailTemplateService {
  private customHttp: CustomHttp
  private openAIEndpoint = environment.openAIUrl

  constructor(
    private http: HttpClient,
    private router: Router,
    private requestLibrary: RequestLibraryService
  ) {
    this.customHttp = new CustomHttp(http, router)
  }

  getPaginatedEmails(body) {
    return this.requestLibrary.GetAll("/emailtemplates", {
      options: body,
    })
  }

  getExportEmails(body) {
    return this.requestLibrary.GetCSV("/emailtemplates", {
      options: body,
    })
  }

  getAllEmails() {
    return this.requestLibrary.Get("/emailtemplates")
  }
  getAllCompactEmails() {
    return this.requestLibrary.GetAll("/emailtemplates", {
      options: { page_size: "all", is_compact: true },
    })
  }

  getEmail(id) {
    return this.requestLibrary.Get("/emailtemplates/" + id)
  }

  // getBarData() {
  //     const relative_date = 'Last 7 Days';
  //     return this.requestLibrary.GetAll('/emailtemplates/reports/sent', {
  //         'options': { date_interval: relative_date }
  //     });
  // }

  deleteEmail(id) {
    return this.requestLibrary.Delete("/emailtemplates/" + id)
  }

  addEmail(model) {
    return this.requestLibrary.Post("/emailtemplates", model)
  }

  editEmail(model) {
    return this.requestLibrary.Post("/emailtemplates", model)
  }

  getEmailTemplatePreview(model) {
    return this.requestLibrary.GetAll("/emailtemplates/preview", {
      template: {
        id: model.id,
        title: model.title,
        contact_id: model.contact_id,
        subject: model.subject,
        raw_html: model.raw_html,
        raw_json: model.raw_json,
      },
    })
  }

  getTemplateLegend() {
    return this.requestLibrary.Get("/templatelegends")
  }

  postTemplateLegend(model) {
    return this.requestLibrary.Post("/templatelegends", model)
  }

  deleteTemplateLegend(id) {
    return this.requestLibrary.Delete("/templatelegends/" + id)
  }

  private extractData(res: Response) {
    let body = res.json()
    return body
  }

  generatePreview(
    templateLegend: any,
    secret_key: string,
    account: any
  ): Observable<string> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${secret_key}`,
    })

    // console.log(headers.get("Authorization")) // SECURITY: do not log API keys

    const systemContent = `You are Marketing Optimizer's AI-driven marketing assistant—an expert in crafting ultra-personalized email previews.<br>
      Follow these global guidelines for every AI variable:
        • Personalize using recipient data.<br>
        • Keep subject lines ≤60 characters.<br>
        • Structure bodies with: Greeting → Hook → Value proposition → Call-to-action.<br>
        • Openers: 1–2 sentences.<br>
        • P.S. lines: ≤50 characters as a personal note or reminder.<br>
        • Format all output in HTML: use <p>…</p> to wrap paragraphs and <br> for line breaks, etc.<br>
        • When target persona information is provided, tailor the message specifically to that audience.<br>
      Use the placeholders in the user message exactly as given; do not replace them here.
      `
    const userContent =
      templateLegend.prompt.replaceAll(
        "{tone}",
        templateLegend.tone.toLowerCase()
      ) + 
      (account?.overview ? ` Company Overview: ${account.overview}` : "") + 
      (account?.pain_points ? `, Company Pain Points: ${account.pain_points}` : "") + 
      (account?.value_proposition ? `, Company Value Proposition: ${account.value_proposition}` : "")

    const body = {
      model: "gpt-4o",
      messages: [
        {
          role: "system",
          content: systemContent.trim(),
        },
        {
          role: "user",
          content: userContent,
        },
      ],
      temperature: 0.7,
      max_tokens: 200,
      top_p: 0.9,
      frequency_penalty: 0.2,
      presence_penalty: 0.2,
    }

    return this.http.post<any>(this.openAIEndpoint, body, { headers }).pipe(
      map(response => {
        if (response.choices && response.choices.length > 0) {
          return response.choices[0].message.content
        }
        return ""
      }),
      catchError(error => {
        console.error("Error generating preview:", error)
        return throwError(error?.error?.error?.message)
      })
    )
  }
}
